import AnalyticsEngineBase from "../analyticsenginebase";
import { insertGTMScriptTag, injectNoScript } from "../../utilities/DOMUtils";

export default class AnalyticsEngineGTMBase extends AnalyticsEngineBase {
  constructor(analyticsManager, options = {}) {
    super(analyticsManager, options);
    insertGTMScriptTag(options.gtmTag);
    injectNoScript(`//www.googletagmanager.com/ns.html?id=${options.gtmTag}`);
  }

  sendToDatalayer(data) {
    if (window.dataLayer) {
      window.dataLayer.push(data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/analytics/engines/analyticsEngineGTMBase.js